<template>
    <v-card class="mt-6 pa-3" color="#eee">
        <v-row>
            <v-col cols="12" sm="12">
                <v-row>
                    <v-btn @click="$emit('deleted', tid)" class="ml-6 mt-3" color="error">刪除</v-btn>
                    <span class="mt-6 ml-3">{{q_index}}.</span>
                    <v-text-field v-model="title" single-line="" @change="go_update" class="input_400 ml-3" label="請輸入問題描述"></v-text-field>
                </v-row>
                <v-row class="ml-3 pl-12">
                    <v-text-field  v-model="description" single-line="" @change="go_update" class="input_400 ml-12" label="新增問題描述/解釋(選填)"></v-text-field>
                </v-row>
                <v-row class="ml-3 pl-12">
                    <v-textarea outlined class="input_700 ml-12" label="回答區域" value="" :disabled="true"></v-textarea>
                </v-row>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    props: {
        tid: {
            type: Number,
            default: -1,
        },
        index: {
            type: Number,
            default: -1,
        },
        question: {
            type: Object,
            default: function () {return {title: "", description: ""}}
        }
    },
    data(){
        return{
            q_index: -1,
            title: "",
            description: "",
        }
    },
    watch:{
        index: function(val){
            this.q_index = val
        },
        question: function(val){
            this.title = this.question.title
            this.description = this.question.description
        }
    },
    mounted(){
        this.q_index = this.index
        this.title = this.question.title
        this.description = this.question.description
    },
    methods: {
        go_update(){
            this.$emit('update', [this.tid, {title: this.title, description: this.description}])
        }
    },
}
</script>